import styled from '@emotion/styled';

const StyledButton = styled.button`
  background-color: black;
  padding: 16px;
  border-radius: 50%;
  width: 56px;
  height: 56px;
  box-shadow: 0px 16px 16px 0px rgba(0, 0, 0, 0.12),
    0px 0px 2px 0px rgba(0, 0, 0, 0.12);
  backdrop-filter: blur(10px);
`;

const Container = styled.div`
  font-family: var(--font-Pretendard);
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  padding: 20px;
  width: 100%;
`;

const StyledTitle = styled.div`
  font-size: 20px;
  font-weight: 500;
  text-align: left;
  width: 100%;
`;

const MenuContainer = styled.div`
  display: flex;
  gap: 8px;
  max-width: 100%;
  overflow-x: scroll;
  padding-right: 50px; /* 그라데이션 너비만큼 패딩을 추가 */
`;

const MenuContainerWrapper = styled.div`
  position: relative;
  max-width: 100%;
  overflow-x: hidden;
  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 50px; /* 그라데이션 효과의 너비 */
    height: 100%;
    pointer-events: none;
    background: linear-gradient(
      to right,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 1)
    );
  }
`;

const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 50vh;
  overflow-y: scroll;
  width: 100%;
`;

export {
  StyledButton,
  Container,
  StyledTitle,
  MenuContainer,
  ListContainer,
  MenuContainerWrapper,
};
